"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionType = void 0;
var SessionType;
(function (SessionType) {
    SessionType["adaptive"] = "adaptive";
    SessionType["wrongAnswers"] = "wrongAnswers";
    SessionType["notesOnly"] = "notesOnly";
    SessionType["multiSection"] = "multiSection";
})(SessionType = exports.SessionType || (exports.SessionType = {}));
